module.exports = __webpack_public_path__ + "static/img/ranking_all_reward_kuang_l.9be6556.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ranking_all_reward_kuang_l.png
// module id = xgrn
// module chunks = 0